// extracted by mini-css-extract-plugin
module.exports = {"root":"HeroSignUpForm_root__FXMKp","welcomeOinq":"HeroSignUpForm_welcomeOinq__hs1sD","oinqInSm":"HeroSignUpForm_oinqInSm__mvbT_","oinqInLg":"HeroSignUpForm_oinqInLg__Ehmek"};